import React from 'react';
import PropTypes from 'prop-types';
import ReactSelect, {components} from 'react-select'
import styles from './Select.scss';


const Select = ({
					name,
					options,
					onChange,
					selected,
					placeholder,
					isDisabled,
					isMulti,
					isGrouped,
					isTransparent,
					error,
					withImage,
					width,
					id,
					isSearchable,
					onBlur
				}) => {
	const customStyles = {
		indicatorSeparator: () => ({
			display: 'none'
		}),
		placeholder: () => ({
			fontStyle: 'italic',
			color: '#cccccb',
			marginLeft: '2px',
			marginRight: '2px',
			position: 'absolute',
			top: '50%',
			transform: 'translateY(-50%)',
			boxSizing: 'border-box',
			height: '100%',
			lineHeight: '40px'
		}),
		placeholderContainer: () => ({
			height: '40px'
		}),
		menu: (base, state) => ({
			backgroundColor: 'white',
			borderRadius: 0,
			boxShadow: '0px 2px 3px 0px rgba(34, 36, 38, 0.15)',
			marginTop: '-1px',
			border: '1px solid #cccccb',
			borderColor: (state.isFocused) ? (isTransparent) ? '#989898' : '#2e67b2' : '#cccccb',
			borderTop: 'none',
			position: 'absolute',
			width: '100%',
			minWidth: (width) ? width : '250px',
			zIndex: 1,
			color: (error !== '') ? (isTransparent) ? '#ff0000' : '#cb2026' : '#333',
			'&:hover': {
				borderColor: (isTransparent) ? '#fff' : '#2e67b2'
			}
		}),
		singleValue: () => ({
			maxWidth: 'calc(100% - 8px)',
			overflow: 'unset',
			position: 'absolute',
			textOverflow: 'unset',
			whiteSpace: 'nowrap',
			top: '50%',
			transform: 'translateY(-50%)',
			boxSizing: 'border-box',
			backgroundColor: (isTransparent) ? 'transparent' : 'white'
		}),
		control: (base, state) => ({
			backgroundColor: (isTransparent) ? 'transparent' : 'white',
			alignItems: 'center',
			borderRadius: 0,
			borderStyle: 'solid',
			borderColor: (error !== '') ? (isTransparent) ? '#ff0000' : '#cb2026' : (state.isFocused) ? (isTransparent) ? '#fff' : '#2e67b2' : '#cccccb',
			borderWidth: '1px',
			cursor: 'default',
			display: 'flex',
			flexWrap: 'wrap',
			justifyContent: 'space-between',
			// '-ms-flex-pack': 'justify',
			outline: '0',
			position: 'relative',
			transition: 'all 100ms',
			boxSizing: 'borderBox',
			'&:hover': {
				borderColor: (isTransparent) ? '#fff' : '#2e67b2'
			},
			paddingLeft: '7px'
		}),
		option: (styles, {data, isDisabled, isFocused, isSelected}) => {
			return {
				...styles,
				backgroundColor: isDisabled
				  ? null
				  : isSelected || isFocused ? 'rgba(0, 0, 0, 0.03)' : null,
				color: isDisabled
				  ? '#ccc'
				  : isSelected
					? 'rgba(0, 0, 0, 0.95)'
					: '#333',
				cursor: isDisabled ? 'not-allowed' : 'default',
				'&:hover': {
					backgroundColor: 'rgba(0, 0, 0, 0.05)',
					color: 'rgba(0, 0, 0, 0.95)'
				}
			};
		},
	};

	const groupStyles = {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'space-between',
	};

	const formatGroupLabel = data => (
	  <div style={groupStyles}>
		  <span>{data.label}</span>
		  <span>{data.options.length}</span>
	  </div>
	);

	const Option = (props) => {
		if (withImage) {
			return (
			  <div style={{display: 'flex', alignItems: 'center'}}>
				  <components.Option {...props} />
				  <span className={props.data.imgClass}/>
			  </div>
			)
		}
		return (
		  <div data-test={`${name}-value-${props.data.value}`}>
			  <components.Option {...props} />
		  </div>
		);
	};

	const ValueContainer = (props) => {
		if (withImage && props.getValue().length > 0) {
			return (
			  <div style={{display: 'flex', alignItems: 'center', width: 'calc(100% - 40px)'}}>
				  <components.ValueContainer {...props} />
				  <span className={props.getValue()[0].imgClass}/>
			  </div>
			);
		}
		return (
		  <components.ValueContainer {...props} />
		)
	};

	const SingleValue = (props) => (
	  <components.SingleValue {...props}>
		  {props.data.labelShort ? props.data.labelShort : props.data.label}
	  </components.SingleValue>
	);


	if (isMulti === true) {
		return (
		  <div>
			  <ReactSelect
				isMulti
				id={id}
				name={name}
				onChange={onChange}
				onBlur={onBlur}
				options={options}
				styles={customStyles}
				placeholder={placeholder}
				isDisabled={isDisabled}
				className={styles.container}
				formatGroupLabel={formatGroupLabel}
				isSearchable={isSearchable}
				components={{ValueContainer}}
				value={
					options.filter((option) => {
						if (selected.indexOf(option.value) !== -1) {
							return true;
						}
					})
				}
			  />
			  {error !== '' && <div className={styles.error}>{error}</div>}
		  </div>
		);
	} else {
		return (
		  <div>

			  <ReactSelect
				id={id}
				name={name}
				onChange={onChange}
				onBlur={onBlur}
				options={options}
				styles={customStyles}
				placeholder={placeholder}
				isDisabled={isDisabled}
				className={styles.container + ' tstselect'}
				formatGroupLabel={formatGroupLabel}
				isSearchable={isSearchable}
				components={{Option, ValueContainer, SingleValue}}
				value={
					(isGrouped) ?
					  options.map((option) => {
						  let res = option.options.filter((o) => {
							  return o.value === selected;
						  });

						  if (res[0]) {
							  return res[0];
						  }
					  })
					  :
					  options.filter((option) => {
						  return option.value === selected;
					  })
				}/>
			  {error !== '' && <div className={styles.error}>{error}</div>}
		  </div>
		);
	}
};
Select.defaultProps = {
	placeholder: 'Select...',
	error: '',
	isSearchable: false
};

//
Select.propTypes = {
	name: PropTypes.string.isRequired,
	onChange: PropTypes.func,
	onBlur: PropTypes.func,
	placeholder: PropTypes.string,
	options: PropTypes.arrayOf(PropTypes.shape({
		value: PropTypes.oneOfType([
			PropTypes.string,
			PropTypes.number
		]),
		label: PropTypes.string.isRequired
	})),
	selected: PropTypes.oneOfType([
		PropTypes.string,
		PropTypes.number,
		PropTypes.array
	]),
	isDisabled: PropTypes.bool,
	isSearchable: PropTypes.bool,
	error: PropTypes.string
};

export default Select;
